import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

export function initi18n(debug: boolean) {
  i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      // backend default loadpath is public/locales
      fallbackLng: 'en',
      lng: 'en',
      debug,
      load: 'currentOnly',
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      react: {
        bindI18n: 'languageChanged loaded',
        bindI18nStore: 'added removed',
        transEmptyNodeValue: '',
        useSuspense: false, // instead of wait which was used in v9
      },
    });
}

initi18n(process.env.NODE_ENV === 'development' || process.env.ENVIRONMENT === 'ed');

export default i18n;
